import { render, staticRenderFns } from "./SlotRoadmap.vue?vue&type=template&id=2b1ff846&"
import script from "./SlotRoadmap.vue?vue&type=script&lang=js&"
export * from "./SlotRoadmap.vue?vue&type=script&lang=js&"
import style0 from "./SlotRoadmap.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports